function FeatureRow({ eyebrow, title, body, bullets, preview, reverse = false, tint }) {
  const reverseClass = reverse ? "lg:[&>div:first-child]:order-2" : "";
  return (
    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${reverseClass}`}>
      <div className={`rounded-3xl p-6 lg:p-10 ${tint}`}>{preview}</div>
      <div className="flex flex-col gap-4">
        <div className="font-mono text-[11px] tracking-[0.18em] text-darkrock/50 uppercase">{eyebrow}</div>
        <h3
          className="iv1-font-display text-2xl sm:text-3xl font-bold text-darkrock leading-tight"
          style={{ textWrap: "balance" }}
        >
          {title}
        </h3>
        <p
          className="text-darkrock/75 text-[15px] sm:text-base leading-relaxed"
          style={{ textWrap: "pretty" }}
        >
          {body}
        </p>
        {bullets && (
          <ul className="mt-1 space-y-2">
            {bullets.map((b, i) => (
              <li key={i} className="flex gap-2.5 items-start text-darkrock/80 text-[14px] leading-relaxed">
                <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-primary-600 shrink-0" />
                <span className="min-w-0 flex-1">{b}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default FeatureRow;
